interface IClosedEyeProps {
  width?: number;
  height?: number;
}

const ClosedEye = ({ width = 28, height = 22 }: IClosedEyeProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28.115 13.854">
      <g
        id="Icons_Line_Eye_Close"
        data-name="Icons / Line / Eye Close"
        transform="translate(1.058 1.014)">
        <path
          id="Path"
          d="M0,0,.648,4.947"
          transform="translate(15.093 7.053)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-2"
          data-name="Path"
          d="M0,0,2.375,4.41"
          transform="translate(19.089 5.83)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-3"
          data-name="Path"
          d="M0,0,3.256,3.776"
          transform="translate(22.744 3.277)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-4"
          data-name="Path"
          d="M.648,0,0,4.947"
          transform="translate(10.259 7.053)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-5"
          data-name="Path"
          d="M2.375,0,0,4.41"
          transform="translate(4.536 5.83)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-6"
          data-name="Path"
          d="M3.256,0,0,3.776"
          transform="translate(0 3.277)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          id="Path-7"
          data-name="Path"
          d="M24.53,0s-3.8,7.212-12.265,7.212S0,0,0,0"
          transform="translate(0.735)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export default ClosedEye;
